import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f9dd8ce8")

_pushScopeId("data-v-f9dd8ce8")
const _hoisted_1 = { class: "flex flex-row text-12px xxl:text-14px items-center" }
const _hoisted_2 = { class: "\n            font-semibold\n            text-20px\n            mr-8\n            whitespace-no-wrap\n            text-black-lp-200\n            capitalize\n          " }
const _hoisted_3 = {
  key: 3,
  class: "px-6 flex flex-col space-y-2"
}
const _hoisted_4 = { class: "px-6 flex flex-col space-y-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_SummaryConsole = _resolveComponent("SummaryConsole")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_CardSection = _resolveComponent("CardSection")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, null, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.currentRoute)), 1)
        ])
      ]),
      _: 1
    }),
    (!_ctx.isConsole)
      ? (_openBlock(), _createBlock(_component_Summary, {
          key: 0,
          data: _ctx.dataSummary,
          roleType: _ctx.roleType
        }, null, 8, ["data", "roleType"]))
      : _createCommentVNode("", true),
    _createVNode(_component_FilterSection, { roleType: _ctx.roleType }, null, 8, ["roleType"]),
    (_ctx.isConsole)
      ? (_openBlock(), _createBlock(_component_SummaryConsole, {
          key: 1,
          data: _ctx.dataSummary,
          roleType: _ctx.roleType
        }, null, 8, ["data", "roleType"]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.dataListDex.length === 0)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 2,
          data: "Dex Assessment",
          style: {"height":"100%"}
        }))
      : _createCommentVNode("", true),
    (_ctx.isLoading && _ctx.isFirstLanding && !_ctx.isInfiniteScroll)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          })
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 4,
          onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          style: {"height":"100%","overflow-y":"scroll"},
          id: "content"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataListDex, (data) => {
            return (_openBlock(), _createBlock(_component_CardSection, {
              key: data,
              data: data,
              roleType: _ctx.roleType
            }, null, 8, ["data", "roleType"]))
          }), 128)),
          _withDirectives(_createVNode("div", _hoisted_4, [
            _createVNode(_component_skeleton, {
              width: "100%",
              height: "20px"
            }),
            _createVNode(_component_skeleton, {
              width: "100%",
              height: "20px"
            })
          ], 512), [
            [_vShow, _ctx.isLoading]
          ])
        ], 32)),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.customStyles?.message,
      customStyles: _ctx.customStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 10,
      class: _ctx.customStyles?.width,
      showIconClose: "",
      customIconClose: "",
      onClose: _ctx.hideNotification
    }, null, 8, ["modelValue", "message", "customStyles", "class", "onClose"])
  ], 64))
})